import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideNativeDateAdapter } from '@angular/material/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { authorizeSessionInterceptor } from './core/interceptors/authorize-session.interceptor';
import { deviceInfoInterceptor } from './core/interceptors/device-info.interceptor';
import { apiErrorInterceptor } from './core/interceptors/api-error.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideNativeDateAdapter(),
    provideHttpClient(
      withInterceptors([
        authorizeSessionInterceptor,
        apiErrorInterceptor,
        deviceInfoInterceptor,
      ]),
    ),
  ],
};
